import type { CSSProperties } from 'react';
import type { CardPublic, DeckBackStyle } from '@tarot/contracts';

interface Props {
  card?: CardPublic | null;
  back?: DeckBackStyle;
  flipped?: boolean;
  reversed?: boolean;
  position?: string;
  label?: string;
  className?: string;
  onClick?: () => void;
}

const DEFAULT_BACK: DeckBackStyle = { color: '#3b1d6e', accent: '#a78bfa', symbol: '✦' };

/** Карта Таро с 3D-переворотом. Лицо — картинка (если есть) или символ+название. */
export function TarotCard({ card, back = DEFAULT_BACK, flipped, reversed, position, label, className = '', onClick }: Props) {
  const style = { '--back': back.color, '--accent': back.accent } as CSSProperties;
  return (
    <div className={`tcard ${className}${flipped ? ' flipped' : ''}${reversed ? ' reversed' : ''}`} style={style} onClick={onClick} role={onClick ? 'button' : undefined}>
      {position && <div className="pos">{position}</div>}
      <div className="inner">
        <div className={`face back${back.image ? ' has-img' : ''}`} style={back.image ? { backgroundImage: `url(${back.image})` } : undefined}>{!back.image && <div className="sym">{back.symbol}</div>}</div>
        <div className={`face front${card?.imageUrl ? ' has-img' : ''}`} style={card?.imageUrl ? { backgroundImage: `url(${card.imageUrl})` } : undefined} role={card?.imageUrl ? 'img' : undefined} aria-label={card?.imageUrl ? card.name : undefined}>
          {card?.imageUrl ? null : (
            <>
              <div className="sym">{card?.symbol ?? '✦'}</div>
              <div className="name">{card?.name ?? ''}</div>
              <div className="num">{card ? toRoman(card.number) : ''}</div>
            </>
          )}
        </div>
      </div>
      {label && <div className="lbl">{label}</div>}
    </div>
  );
}

function toRoman(n: number): string {
  if (n === 0) return '0';
  let r = '';
  for (const [v, s] of [[10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']] as const) while (n >= v) { r += s; n -= v; }
  return r;
}
